export default {
  userDepartments: [],
  userDepartmentInfos: null
}
